import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

// components
import ThemeMenuOne from '../../../components/header/ThemeMenuOne'
import NewsletterOne from '../../../components/call-to-action/NewsletterOne'
import PageTitle from '../../../components/page-title/PageTitle'
import FooterOne from '../../../components/footer/FooterOne'

const Error = () => {
  return (
    <Fragment>
      <div className="main-page-wrapper">

        {/* Helmet start */}
        <Helmet>
          <title>Error-404 || Techy – IT Solution & Web Security React Template</title>
        </Helmet>
        {/* Helmet end */}

        <ThemeMenuOne />
        <PageTitle title="Error 404" />

        {/*error-page start*/}
        <div className="error-page pt-150 pb-115 pt-lg-60 pb-lg-50">
          <div className="error-page-bg">
            <img
              className="error-shape d-none d-lg-inline-block"
              src="assets/img/shape/line-round-11f.svg"
              alt="Shape"
            />
            <div className="container">
              <div className="row gx-4 gx-xxl-5">
                <div className="col-lg-12">
                  <div className="error-page-wrapper mb-60">
                    <div className="section-title text-center mb-60">
                      <h2 className="sect-title text-white">Oops!<br />Page not found</h2>
                    </div>
                    <img className="w-100" src="assets/img/error/404.svg" alt="error-imgs" />
                  </div>
                </div>
              </div>
              <div className="row gx-4 gx-xxl-5">
                <div className="col-lg-12 text-center">
                  <Link className="theme_btn" to="/">Back To Home</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*error-page end*/}

        <NewsletterOne />
        <FooterOne />
      </div>
    </Fragment>
  )
}

export default Error
